const INVALID_LOGO_URL = 'https://cdn.dev.kitopiconnect.com/_200_200.';

export const isValidLogoUrl = (url: string) => url !== INVALID_LOGO_URL;
